import { useCallback } from "react";

import { usePromise } from "@touchtech/web-hooks";

import { api, createOrderCheckoutUrl } from "@is/services";
import { Order } from "@is/types";

type State = {
  isPending: boolean;
  error: Error | null;
  data: Order | null;
};

async function handleOrderCheckout(params: Order): Promise<Order> {
  const url = createOrderCheckoutUrl();
  try {
    const data = (await api.post(url, params)) as Order;
    return data;
  } catch (error) {
    const enrichedError = { ...(error as any), __endpoint: url };
    throw enrichedError;
  }
}

export const useOrderCheckout = (): [
  State,
  (params: Order) => Promise<Order>
] => {
  const [{ isPending, error, data }, dispatch] = usePromise<Order>();

  const orderCheckout = useCallback(
    (params: Order) => dispatch(handleOrderCheckout(params)),
    [dispatch]
  );

  return [{ isPending, error, data }, orderCheckout];
};
